import React, { useState, useEffect } from "react";
import { messages } from "../../variables/data";

//STYLES FILES
import "./../../Assets/css/Card.css";

//env variable
const time_out = process.env.REACT_APP_TIME_OUT;

export const BannerCard = ({
  status,
  setDisplay_banner,
  room_name,
  prepare,
}) => {
  const [alertMessage, setAlertMessage] = useState([]);

  useEffect(() => {
    if (room_name) {
      let findMessage = messages.find(
        (item) => item.status === status && item.prepared === prepare
      );
      let msg = findMessage?.msg.replace("Room", room_name);
      let Message = { ...findMessage };
      Message.msg = msg;
      findMessage = Message;
      setAlertMessage(findMessage);
    }
  }, [status, room_name, prepare]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplay_banner(false);
    }, time_out);

    return () => clearInterval(interval);
  });

  const handleBanner = () => {
    setDisplay_banner(false);
  };

  return (
    <div
      className="bannerCard"
      style={{ backgroundColor: `${alertMessage?.background}` }}
    >
      <p style={{ color: `${alertMessage?.color}` }}>{alertMessage?.msg}</p>
      <img src={alertMessage?.img} alt="Icons" onClick={handleBanner} />
    </div>
  );
};
